import { render } from "./AutoComplete.vue?vue&type=template&id=396f38c4&scoped=true"
import script from "./AutoComplete.vue?vue&type=script&lang=js"
export * from "./AutoComplete.vue?vue&type=script&lang=js"

import "./AutoComplete.vue?vue&type=style&index=0&id=396f38c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396f38c4"]])

export default __exports__